import User from "byzantine/src/User";

export const checkAuthSession = async (
  logoutMessage?: string
): Promise<void> => {
  try {
    const user = await User.getUser();
    if (!user) {
      window.location.assign(
        `/login${
          logoutMessage ? `?info=${encodeURIComponent(logoutMessage)}` : ""
        }`
      );
    }
  } catch (_) {
    // skip network issues, user would still be un-authed on the server
  }
};

export default checkAuthSession;
